module.exports = __webpack_public_path__ + "img/err-network-3segments.1e4b0a28.svg";